import axios from 'axios'

import { receiveSuccessAlert } from '@/actions/alerts'
import { handleRequestError } from '@/actions/request'
import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING } from '@/constants'

export const REQUEST_INCOME_PLATFORMS = 'REQUEST_INCOME_PLATFORMS'
export const RECEIVE_INCOME_PLATFORMS = 'RECEIVE_INCOME_PLATFORMS'
export const ADD_INCOME_PLATFORM_CONNECTION = 'ADD_INCOME_PLATFORM_CONNECTION'
export const REMOVE_INCOME_PLATFORM_CONNECTION = 'REMOVE_INCOME_PLATFORM_CONNECTION'
export const UPDATE_INCOME_PLATFORM_DATA = 'UPDATE_INCOME_PLATFORM_DATA'
export const REQUEST_INCOME_PLATFORMS_SESSION_TOKEN = 'REQUEST_INCOME_PLATFORMS_SESSION_TOKEN'

export const requestIncomePlatforms = (selfAssessmentId) => (dispatch) => {
    dispatch({ type: REQUEST_INCOME_PLATFORMS, selfAssessmentId })

    return axios
        .get(`/selfassessments/${selfAssessmentId}/incomeplatforms`)
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveIncomePlatforms({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveIncomePlatforms({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveIncomePlatforms = (data) => ({ type: RECEIVE_INCOME_PLATFORMS, data })

export const connectIncomePlatform =
    ({ selfAssessmentId, platformId, externalId }) =>
    (dispatch) => {
        dispatch({ type: ADD_INCOME_PLATFORM_CONNECTION, selfAssessmentId, platformId, externalId })

        return axios
            .post(`/selfassessments/${selfAssessmentId}/incomeplatforms/${platformId}`, { externalId })
            .then(() => {
                dispatch(requestIncomePlatforms(selfAssessmentId))
                dispatch(receiveSuccessAlert('Platform connected'))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const removeIncomePlatformConnection =
    ({ selfAssessmentId, platformId }) =>
    (dispatch) => {
        dispatch({ type: REMOVE_INCOME_PLATFORM_CONNECTION })

        return axios
            .delete(`/selfassessments/${selfAssessmentId}/incomeplatforms/${platformId}`)
            .then(() => {
                dispatch(requestIncomePlatforms(selfAssessmentId))
                dispatch(receiveSuccessAlert('Platform connection removed'))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
            })
    }

export const updateIncomePlatformData =
    ({ selfAssessmentId, platformId, data }) =>
    (dispatch) => {
        dispatch({ type: UPDATE_INCOME_PLATFORM_DATA })

        return axios
            .put(`/selfassessments/${selfAssessmentId}/incomeplatforms/${platformId}/data`, data)
            .then((response) => {
                const responseData = response?.data || []
                dispatch(receiveIncomePlatforms({ items: [responseData], fetchSuccessful: true }))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const requestIncomePlatformsSessionToken = (selfAssessmentId) => (dispatch) => {
    dispatch({ type: REQUEST_INCOME_PLATFORMS_SESSION_TOKEN, selfAssessmentId })

    return axios
        .get(`/selfassessments/${selfAssessmentId}/incomeplatforms/sessiontoken`)
        .then((response) => response?.data || null)
        .catch((error) => {
            dispatch(handleRequestError(error))
        })
}
